const IconLinkedin = ({
  width = "40",
  height = "40",
  fill = "#0277B4",
  fill2 = "#fff",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : null}
      data-name="IconLinkedin"
    >
      <path
        d="M29 3H11C6.58172 3 3 6.58172 3 11V29C3 33.4183 6.58172 37 11 37H29C33.4183 37 37 33.4183 37 29V11C37 6.58172 33.4183 3 29 3Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2173 14.4346C9.44046 14.4346 8 12.9942 8 11.2173C8 9.44046 9.44046 8 11.2173 8C12.9942 8 14.4346 9.44046 14.4346 11.2173C14.4346 12.9942 12.9943 14.4346 11.2173 14.4346ZM13.8667 30.9922C13.8667 31.4316 13.5105 31.7878 13.0711 31.7878H9.6845C9.2451 31.7878 8.88892 31.4316 8.88892 30.9922V16.7956C8.88892 16.3562 9.2451 16 9.6845 16H13.0711C13.5105 16 13.8667 16.3562 13.8667 16.7956V30.9922ZM30.7246 31.1373C31.1286 31.1373 31.4561 30.8098 31.4561 30.4058V23.5349L31.4561 23.4842C31.4563 20.4868 31.4567 15.1113 25.6703 15.1113C23.0425 15.1113 21.8083 16.0733 20.9778 17.3196V16.0811C20.9778 15.6771 20.6503 15.3495 20.2463 15.3495H16.7315C16.3275 15.3495 16 15.6771 16 16.0811V30.4058C16 30.8098 16.3275 31.1373 16.7315 31.1373H20.2463C20.6503 31.1373 20.9778 30.8098 20.9778 30.4058V22.7253C21.069 21.6934 21.5233 19.3938 23.763 19.3938C26.4377 19.3938 26.3847 22.2767 26.3624 23.491C26.3606 23.5876 26.359 23.6736 26.359 23.7468V30.4058C26.359 30.8098 26.6866 31.1373 27.0905 31.1373H30.7246Z"
        fill={fill2}
      />
    </svg>
  );
};
export default IconLinkedin;
